module.exports = __webpack_public_path__ + "src/assets/img/product-snail.595a21a9.png";